import { RootState } from '../../store';
import { FlowState, Step } from '../../../types/flow';

export const selectFlowSteps = (state: RootState): Array<Step> | undefined =>
  state.flow?.steps;

export const selectCurrentStepKey = (state: RootState): string | undefined => {
  const length = state.flow.steps.length;
  return state.flow?.steps[length - 1]?.key;
};

export const selectCurrentStep = (state: RootState): FlowState['currentStep'] =>
  state.flow?.currentStep;

export const selectNextStepPath = (
  state: RootState
): FlowState['nextStepPath'] => state.flow?.nextStepPath;

export const selectPrevStepPath = (
  state: RootState
): FlowState['prevStepPath'] => state.flow?.prevStepPath;

export const selectOriginPath = (state: RootState): FlowState['originPath'] =>
  state.flow?.originPath;

export const selectCurrentFlow = (state: RootState): FlowState['currentFlow'] =>
  state.flow?.currentFlow;
